import { Select, Option } from 'element-ui'
import HttpFactory from '@/mixins/http.factory';
import customAgGrid from '@/components/custom-ag-grid/custom-ag-grid.vue';
import mappingActionsRenderer from '@/components/admin/mappingActionsRenderer.vue';

export default {
	name:'devops-field-mapping',
	mixins:[HttpFactory],
	props:{
		userInfo: {
			type: Object,
			required: true,
			default: () => true
		},
		fieldMappingTypes:{
			type: Array,
			required: true,
			default: () => true
		},
	},
	data () {
		return {
			data:null,
			showFields:true,
			serviceDeskName:null,
			syncingTypes:[{name:'Forward',value:'forward'},{name:'Reverse',value:'reverse'},{name:'Both',value:'both'}],
			fieldMapping:{type:'ticket'},
			selectedField:{adoField:null,hdField:null,maxAllowed:0},
			fieldMappingDb:{fieldMapping:[],hdFields:[],devOpsFields:[]},
			fieldMappingUI:{mappingType:'ticket',fieldMapping:[],hdFields:[],devOpsFields:[]},
			columnDefs:[],
			gridOptionsApi:null,
			dataList:[]
		}
	},
	created(){
		this.init(true);
	},
	methods:{
		async init(loadFields){
			let _self=this;
			
			if(_self.userInfo.requestType.indexOf('zendesk')>=0) _self.serviceDeskName='Zendesk';
			if(_self.userInfo.requestType.indexOf('freshdesk')>=0) _self.serviceDeskName='Freshdesk';
			if(_self.userInfo.requestType.indexOf('freshservice')>=0) _self.serviceDeskName='Freshservice';

			_self.resetDefault();
			_self.initDefaultNewField();
			_self.initCols();
			if(loadFields===true){
				await _self.getFieldsDataDb();
			}
			await _self.getFieldMappingDb();
		},
		hideEditFieldMappingFn(){
			this.$emit('hideEditFieldMappingFn',{});
		},
		resetDefault(){
			const _self=this;
			_self.fieldMapping={type:_self.fieldMapping.type};
			_self.showFields=false;
			setTimeout(function(){_self.showFields=true;},500);
			_self.selectedField={adoField:null,hdField:null,maxAllowed:0};
		},
		async initDefaultNewField(){
			const _self=this;
			let fieldMapping={type:_self.fieldMapping.type,userId:_self.userInfo.userId,hdFieldName:null,hdFieldType:null,hdFieldMappingId:null,
				devOpsFieldName:null,devOpsFieldType:null,devOpsFieldMappingId:null,workItemType:null,syncingType:'forward',isActive:1,
				options:[],showChoices:false,hdCompOrgId:null
			}
			setTimeout(function(){_self.fieldMapping=fieldMapping;},500);
		},
		async getFieldsDataDb(){
			let _self=this;
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			
			let url =`fieldmapping/fields/${_self.userInfo.userId}/${_self.userInfo.requestType}/${_self.fieldMapping.type}`;
			let response=await _self.get(url);
			_self.fn().showLoader(false);
			let fieldMapping=JSON.stringify(response.data.Data);
			_self.fieldMappingDb=JSON.parse(fieldMapping);
			//fieldMapping=fieldMapping.replace(/system_field_options/g, 'choices');
			//fieldMapping=fieldMapping.replace(/custom_field_options/g, 'choices');
			
			fieldMapping=JSON.parse(fieldMapping);
			//fieldMapping.hdFields=fieldMapping.hdFields.filter(d=>d.removable);
			fieldMapping.devOpsFields=fieldMapping.devOpsFields.value.filter(d=>!d.readOnly);

			//fieldMappingUI is used to re construct the fields to UI
			_self.fieldMappingUI=fieldMapping;
		},
		async getFieldMappingDb(){
			let _self=this;
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			
			let url =`fieldmapping/data/${_self.userInfo.userId}/${_self.userInfo.requestType}/${_self.fieldMapping.type}`;
			let response=await _self.get(url);
			_self.fn().showLoader(false);
			let fieldMapping=response.data.Data.fieldMapping;
			_self.dataList=fieldMapping?fieldMapping:[];
			
		},
		mappingTypeChange(fieldEditBind,loadDbData){
			const _self=this;

			//if undefined then its for new field only and we can reset on change
			if(fieldEditBind===undefined || fieldEditBind===null){
				_self.initDefaultNewField();
				if(_self.serviceDeskName=='Freshdesk') return;
				_self.showFields=false;
				_self.fieldMapping.hdFieldMappingId='';
			}
			
			if(_self.fieldMapping.type=='organization'){
				let fieldMapping=JSON.parse(JSON.stringify(_self.fieldMappingDb));
				_self.fieldMappingUI.hdFields=fieldMapping.organization_fields;
			}

			if(_self.fieldMapping.type=='ticket'){
				let fieldMapping=JSON.parse(JSON.stringify(_self.fieldMappingDb));
				_self.fieldMappingUI.hdFields=fieldMapping.hdFields;
			}

			if(_self.fieldMapping.type=='change'){
				let fieldMapping=JSON.parse(JSON.stringify(_self.fieldMappingDb));
				_self.fieldMappingUI.hdFields=fieldMapping.change_fields;
			}
			//when the field type in UI is changed and we need to reload the data from db based on type
			if(loadDbData===true){
				_self.getFieldMappingDb(true);
			}
			setTimeout(function(){_self.showFields=true;},500);
		},
		handleFieldType:function(currentField,fieldMappingId,type){
			let _self=this;
			let showChoices=false;
			if(type=='devops'){
				let field=_self.fieldMappingUI.devOpsFields.find(d=>d.referenceName==fieldMappingId);
				if(field){
					_self.selectedField.adoField=field;
					currentField.devOpsFieldName=field.name;
					currentField.devOpsFieldType=field.type;
				}
			}
			if(type=='Zendesk' || type=='Freshdesk' || type=='Freshservice'){
				//let field=_self.fieldMappingUI.hdFields.find(d=>d.id==fieldMappingId || d.key==fieldMappingId);
				let field=_self.fieldMappingUI.hdFields.find(d=>d.id==fieldMappingId || d.key==fieldMappingId || d.name==fieldMappingId);
				
				if(field){
					_self.selectedField.hdField=field;
					currentField.hdFieldName=field.title?field.title:(field.label?field.label:field);
					currentField.hdFieldType=field.type;
					let isCustomField=field.removable?true:false;
					isCustomField=field.system_field_options!==undefined?false:true;
					currentField.hdIsCustomField=isCustomField;
					if(_self.fieldMapping.type=='organization'){
						currentField.hdCompOrgId=field.id;
					}
				}
			}

			if(_self.selectedField.adoField && _self.selectedField.hdField){
				showChoices=(_self.selectedField.adoField.isPicklist || _self.selectedField.adoField.isIdentity || _self.selectedField.adoField.type=='boolean')?true:false;
				if(!showChoices && _self.selectedField.adoField.allowedValues && _self.selectedField.adoField.allowedValues.length>0) showChoices=true;
			
				if(_self.selectedField.hdField){
					if(_self.serviceDeskName=='Zendesk'){
						let choices=_self.selectedField.hdField.custom_field_options?_self.selectedField.hdField.custom_field_options:_self.selectedField.hdField.system_field_options;
						showChoices=(showChoices && choices && choices.length>0)?true:false;
					}else{
						showChoices=(showChoices && _self.selectedField.hdField.choices && Object.keys(_self.selectedField.hdField.choices).length>0)?true:false;
					}
				}
			}else{
				showChoices=false;
			}
			currentField.showChoices=showChoices;
			if(showChoices){
				_self.addDefaultOptionObj();
			}else{
				_self.fieldMapping.options=[];
			}
		},
		isPlusAllowed(){
			const _self=this;
			if(!_self.fieldMapping.showChoices) return;
			let isAllowed=false;
			let index=_self.fieldMapping.options.length;
			//validation
			let hdlength;
			if(_self.serviceDeskName=='Zendesk'){
				hdlength=(_self.selectedField.hdField.custom_field_options?_self.selectedField.hdField.custom_field_options:_self.selectedField.hdField.system_field_options).length;
			}else{
				hdlength=Object.keys(_self.selectedField.hdField.choices).length;
			}
			let adoLength=0;
			if(_self.selectedField.adoField.allowedValues && Array.isArray(_self.selectedField.adoField.allowedValues)){
				adoLength=_self.selectedField.adoField.allowedValues.length;
			}
			if(_self.selectedField.adoField.type=='boolean'){
				adoLength=2;
			}
			if(_self.selectedField.adoField.isIdentity && _self.userInfo.isUsersAccess && _self.fieldMappingUI.usersList.value){
				adoLength=_self.fieldMappingUI.usersList.value.length;
			}
			let maxAllowed=hdlength<adoLength?hdlength:adoLength;
			isAllowed=index<maxAllowed?true:false;
			_self.selectedField.maxAllowed=maxAllowed;
			return isAllowed;
		},
		onHDOptionSelect(fieldOption,optInd){
			const _self=this;
			let option;
			
			if(_self.serviceDeskName=='Zendesk'){
				let choices=_self.selectedField.hdField.custom_field_options?_self.selectedField.hdField.custom_field_options:_self.selectedField.hdField.system_field_options;
				option=choices.find(d=>d.value==fieldOption.hdOptionText || d==fieldOption.hdOptionText);
				
				if(option){
					fieldOption.hdOptionId=_self.selectedField.hdField.key?_self.selectedField.hdField.key:_self.selectedField.hdField.id;
					fieldOption.hdOptionValue=option.value?option.value:option.value;
				}
			}else{
				option=_self.selectedField.hdField.choices[fieldOption.hdOptionText];
				if(option){
					fieldOption.hdOptionId=_self.selectedField.hdField.key?_self.selectedField.hdField.key:_self.selectedField.hdField.id;
					fieldOption.hdOptionValue=option;
				}
			}
		},
		onDevOpsOptionSelect(fieldOption,optInd){
			const _self=this;
			fieldOption.devOpsOptionId=_self.selectedField.adoField.referenceName;
			fieldOption.devOpsOptionText=fieldOption.devOpsOptionValue;
		},
		addDefaultOptionObj(){
			const _self=this;
			let index=_self.fieldMapping.options.length;
			if(!_self.isPlusAllowed()) return;

			let defaultObj={
				index:index,
				fieldmappingId:null,hdOptionId:null,hdOptionText:null,hdOptionValue:null,
				devOpsOptionId:null,devOpsOptionText:null,devOpsOptionValue:null,isActive:1
			};
			_self.fieldMapping.options.push(defaultObj);

		},
		removeOptionObj(index){
			const _self=this;
			_self.fieldMapping.options=_self.fieldMapping.options.filter(d=>d.index!=index);
		},
		validateIfBothHasOptions(){
			const _self=this;
			let showADOChoices=false;
			let showHDChoices=false;
			if(_self.selectedField.adoField && _self.selectedField.hdField){
				showADOChoices=(_self.selectedField.adoField.isPicklist || _self.selectedField.adoField.isIdentity || _self.selectedField.adoField.type=='boolean')?true:false;
				if(!showADOChoices && _self.selectedField.adoField.allowedValues && _self.selectedField.adoField.allowedValues.length>0) showADOChoices=true;
			
				if(_self.selectedField.hdField){
					if(_self.serviceDeskName=='Zendesk'){
						let choices=_self.selectedField.hdField.custom_field_options?_self.selectedField.hdField.custom_field_options:_self.selectedField.hdField.system_field_options;
						showHDChoices=(choices && choices.length>0)?true:false;
					}else{
						showHDChoices=(_self.selectedField.hdField.choices && Object.keys(_self.selectedField.hdField.choices).length>0)?true:false;
					}
				}
			}
			return (showHDChoices!=showADOChoices)?false:true;
		},
		saveUpdateFieldMappingDataFn(){
			const _self=this;
			//commented as we need to allowing mapping dropdown to textfield and textfield to dropdown as well
			// if(!_self.validateIfBothHasOptions()){
			// 	_self.userMsg={show:true,type:'danger',list:[`Both selected values in the dropdown should be either options or without options`]}
			// 	return;
			// }
			if(_self.fieldMapping.id>0){
				_self.updateFieldMappingFn(_self.fieldMapping)
			}else{
				_self.saveFieldMappingDataFn();		
			}
		},
		saveFieldMappingDataFn(){
			const _self=this;
			_self.fn().clearMessage();
			let url=`fieldmapping/${_self.userInfo.userId}/${_self.userInfo.requestType}/${_self.fieldMapping.type}`;
			let data=_self.fieldMapping;
			
			_self.fn().showLoader(true);
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				//let data=response.data.Data;
				let userMsg;
				if(response.data.Success){
					userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Field Mapping data saved Successfully`]}
					_self.init(false);
				}else{
					userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`Field Mapping save failed`]}
				}
				setTimeout(function(){_self.userMsg=userMsg;},500);
				
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		onGridOptionsApi(params){
            const _self=this;
            _self.fn().clearMessage();
            _self.gridOptionsApi=params;
            //setTimeout(function(){_self.filterData();},200);
        },
		editCustomerConfig(params){
			const _self=this;
			let data=params.data;
		},
		//edit
		async extraCallBackFn(params){
			const _self=this;
			let data=params.data;
			_self.fieldMapping.type=data.type;//according to this will settle the UI options
			if(data.type!='ticket'){
				await _self.mappingTypeChange(true,false);
			}
			let options=data.options?JSON.parse(JSON.stringify(data.options)):[];
			data.hdFieldMappingId=data.hdFieldMappingId>0?parseInt(data.hdFieldMappingId):data.hdFieldMappingId;
			_self.fieldMapping=data;
			_self.handleFieldType(_self.fieldMapping,_self.fieldMapping.hdFieldMappingId,_self.serviceDeskName);
			_self.handleFieldType(_self.fieldMapping,_self.fieldMapping.devOpsFieldMappingId,'devops');

			for(var i=0;i<options.length;i++){
				options[i].index=i;
			}
			_self.fieldMapping.options=options;
			
			//_self.$forceUpdate();
		},
		cancelEditFieldMappingFn(){
			const _self=this;
			_self.init(false);
		},
		//toggle active
		extraCallBackFn1(params){
			const _self=this;
			let data=params.data;
			if(confirm(`Are you sure you want to toggle the field mapping ${data.id} of hdFieldName:${data.hdFieldName} and devOpsFieldName:${data.devOpsFieldName}`)){
				data.isActive=!data.isActive;
				_self.updateFieldMappingFn(data);	
			}
		},
		async updateFieldMappingFn(data){
			const _self=this;
			
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			let url =`fieldmapping/${data.userId}/${_self.userInfo.requestType}/${data.type}/${data.id}`;
			let response=await _self.put(url,data);
			_self.fn().showLoader(false);
			let userMsg;
			if(response.data.Success){
				userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Field Mapping data updated Successfully`]}
				_self.init(false);
			}else{
				userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`Field Mapping update failed`]}
			}
			setTimeout(function(){_self.userMsg=userMsg;},500);
		},
		//delete
		extraCallBackFn2(params){
			const _self=this;
			let data=params.data;
			if(confirm(`Are you sure you want to delete the field mapping ${data.id} of hdFieldName:${data.hdFieldName} and devOpsFieldName:${data.devOpsFieldName}`)){
				_self.deleteFieldMappingFn(data);
			}
		},
		async deleteFieldMappingFn(data){
			const _self=this;
			
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			let url =`fieldmapping/delete/${data.userId}/${_self.userInfo.requestType}/${data.type}/${data.id}`;
			let response=await _self.delete(url);
			_self.fn().showLoader(false);
			let userMsg;
			if(response.data.Success){
				userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Field Mapping data deleted Successfully`]}
				_self.init(false);
			}else{
				userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`Field Mapping delete failed`]}
			}
			setTimeout(function(){_self.userMsg=userMsg;},500);
		},
		initCols(){
            const _self  =this;
            _self.columnDefs=[];
          
            let commonWidth=125;//=120;
            _self.columnDefs = [
                { headerName: 'Field Id',field: 'id', width: commonWidth,},
				{ headerName: 'Type',field: 'type', width: commonWidth,},
				{ headerName: 'hdFieldName',field: 'hdFieldName', width: commonWidth,},
				{ headerName: 'hdFieldType',field: 'hdFieldType', width: commonWidth,},
				{ headerName: 'hdFieldMappingId',field: 'hdFieldMappingId', width: commonWidth,},
				{ headerName: 'devOpsFieldName',field: 'devOpsFieldName', width: commonWidth,},
				{ headerName: 'devOpsFieldType',field: 'devOpsFieldType', width: commonWidth,},
				{ headerName: 'devOpsFieldMappingId',field: 'devOpsFieldMappingId', width: commonWidth,},
				{ headerName: 'workItemType',field: 'workItemType', width: commonWidth,},
				{ headerName: 'syncingType',field: 'syncingType', width: commonWidth,},
				{ headerName: 'Options',field: 'fieldmappingOptionId', width: commonWidth,
					valueFormatter:function(params){return params.value>0?'Yes':'No';}
				},
				{ headerName: 'Action',field: 'id', minWidth: 400,cellRendererFramework:mappingActionsRenderer},
			];
        },
	},
	components:{[Select.name]: Select,[Option.name]: Option,customAgGrid}
}

